import React from "react";
import withRoute from "./withRoute";

export const Route = ({ component, ...props}: any)=> {
  return React.createElement(withRoute(component), props);
}

export default Route;
